<template>
  <section v-if="name === 'tabs'" class="section">
    <div class="section-header with-border">
      设置
    </div>
    <div class="section-body">
      <el-form label-width="100px">
        <el-form-item label="背景色">
          <el-color-picker v-model="config.backgroundColor"></el-color-picker>
        </el-form-item>
        <el-form-item label="默认颜色">
          <el-color-picker v-model="config.color"></el-color-picker>
        </el-form-item>
        <el-form-item label="选中颜色">
          <el-color-picker v-model="config.selectedColor"></el-color-picker>
        </el-form-item>
        <el-form-item label="设置tabBar">
          <div class="setting-item" v-for="(item, index) in data">
            <div v-if="index > 1" class="setting-remove" @click="removeItem(index)"><i class="iconfont icon-trash-alt"></i></div>
            <img v-if="item.iconPath" :src="item.iconPath" class="icon-setter" @click="handleIconChange(index)"/>
            <div class="icon-setter" v-else @click="handleIconChange(index)">
              <i class="iconfont icon-image muted"></i>
            </div>
            <img v-if="item.selectedIconPath" :src="item.selectedIconPath" class="icon-setter" @click="handleSelectedIconChange(index)"/>
            <div class="icon-setter" v-else @click="handleSelectedIconChange(index)">
              <i class="iconfont icon-image muted"></i>
            </div>
            <div class="uploader-setting">
              <el-input placeholder="tab名称" v-model="item.text" maxlength=""></el-input>
            </div>
            <div class="uploader-setting">
              <el-select v-model="item.pagePath" placeholder="设置tab路径" @focus="handleClick(index)" @change="handleChange" @blur = "handleRemove(index)">
                <el-option
                  v-for="item in pathOptions"
                  :key="item.value"
                  :label="item.name == 'custom_link' ? (item.title ? (item.label + ':' + item.title ): item.label): item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>   
          </div>
          <div class="frm-tips">只能上传jpg/png文件，且不超过2M （建议尺寸：375px * 200px）</div>
          <el-button :disabled="data.length >= 5" type="default" class="iconfont icon-plus-circle banner-button-uploader" @click="addItem"> 添加菜单项</el-button>
        </el-form-item>
      </el-form>
    </div>
  </section>
</template>

<script>
  export default {
    props: {
      res: {
        type: Object,
        default: {}
      }
    },
    watch: {
      res: {
        deep: true,
        handler (value) {
          if (value) {
            this.setData(value)
          }
        }
      }
    },
    data () {
      return {
        aa:'',
        numL:0,
        name: '',
        config: {},
        current: '',
        data: [],
        iconColor: '',
        selectedIconColor: '',
        pathOptions: [{
          value: '/pages/index',
          name: 'home',
          label: '首页'
        },
        {
          value: '/pages/cart/espier-index',
          name: 'cart',
          label: '购物车'
        },
        {
          value: '/pages/category/index',
          name: 'category',
          label: '分类'
        },
        {
          value: '/pages/member/index',
          name: 'member',
          label: '我的'
        },
        {
          value: '/pages/recommend/list',
          name: 'article',
          label: '软文'
        },
	      {
          value: '/pages/link/list',
          name: 'custom_link',
          label: '自定义链接'
        }]
      }
    },
    methods: {
      setData(val) {
        this.name = val.name
        this.config = val.config
        this.data = val.data;
        if (val.data) {
          this.pathOptions.forEach((item,key) =>{
            val.data.forEach((items,keys) =>{
              if (items['pagePath'] ==  item['value'] && items['pagePath'] == "/pages/link/list") {
                this.pathOptions[key]['title'] = items['title']
              }
            })
          })
          this.pathOptions = this.pathOptions
        }
      },
      addItem () {
        if (!this.data) {
          this.data = []
        }
        let item = {
          pagePath: '',
          text: '',
          name: '',
          iconPath: '',
          selectedIconPath: ''
        }
        if(this.data.length > 4) {
          this.$message({
            message: '轮播图最多添加5个图片',
            type: 'error',
            duration: 5 * 1000
          })
        } else {
          this.data.push(item)
        }
      },
      removeItem (index) {
        this.data.splice(index, 1)
      },
      handleRemove(index){
        if (this.numL == 1) {
          this.linkPublic(index); 
        }
      },
      linkPublic(index){
        if (this.data[index]['title'] != undefined) {
          this.data[index]['pagePath'] = '自定义链接:'+this.data[index]['title'];
        }
      },
      handleClick (index) {
        this.current = index
        if (this.data[index]['pagePath'] == '/pages/link/list') {
          this.linkPublic(index); 
          if (this.numL == 0) {
            this.$emit('bindLinked', this.current);
            this.numL = 1;
          }
          else{
            this.data[index]['pagePath'] = '';
          }
        }
      },
      handleChange (value) {
        let n = this.pathOptions.find(item => item.value === value)
	      if (n) {
          console.log(n.name,'tabs_name')
          this.data[this.current].name = n.name;
          if (n.name == 'custom_link') {
            console.log(this.data,'自定义链接')
            this.$emit('bindLinked', this.current);
          }
          else{
            delete this.data[this.current].title;
            delete this.data[this.current].custom_content;
            delete this.data[this.current].linkPage;
            delete this.data[this.current].id;
            this.$emit('closeDialog', 'link')
          }
        }
      },
      handleIconChange (index) {
        this.$emit('bindImgs', index, 'default')
      },
      handleSelectedIconChange (index) {
        this.$emit('bindImgs', index, 'selected')
      }
    },
    mounted() {
      this.setData(this.res)
    }
  }
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// tab_bar.vue?2cb9b40e